import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ff8d1c60")

_pushScopeId("data-v-ff8d1c60")
const _hoisted_1 = {
  class: "grid",
  style: {"width":"900px"}
}
const _hoisted_2 = { class: "flex justify-end mt-10 gap-x-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SendInvoiceReceiverRows = _resolveComponent("SendInvoiceReceiverRows")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.show,
    title: _ctx.modalTitle,
    class: "send-invoice",
    "onUpdate:modelValue": _ctx.onCloseModal
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_SendInvoiceReceiverRows, {
          viaOptions: _ctx.viaOptions,
          formatOptions: _ctx.formatOptions,
          onUpdate: _ctx.onReceiversUpdate
        }, null, 8, ["viaOptions", "formatOptions", "onUpdate"])
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_button_fill, {
          onClick: _ctx.onSubmit,
          title: _ctx.$t('tagihan.create.save'),
          class: "bg-red-lp-300 px-8 w-full",
          isDisabled: _ctx.isDisabledSubmit,
          isLoading: _ctx.isLoadingSend
        }, null, 8, ["onClick", "title", "isDisabled", "isLoading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onUpdate:modelValue"]))
})